import React from "react";
import { Modal, InputNumber, Select, Radio } from "antd";
import PropTypes, { string } from "prop-types";
import { Form } from "@ant-design/compatible";

//Redux
import { connect } from "react-redux";
import { getAllBusinessBranches } from "../../../../../../redux/actions/branchActions";
import {
  sendInventory,
  getAllProducts,
  sendInventoryVariants,
  sendBranchProductToMain,
  sendBranchProductToBranch,
} from "../../../../../../redux/actions/productActions";
import strings from "../../../../../../strings";

const Option = Select.Option;

// Transfer type constants
const TRANSFER_TYPES = {
  HOME_TO_BRANCH: 'home_to_branch',
  BRANCH_TO_HOME: 'branch_to_home', 
  BRANCH_TO_BRANCH: 'branch_to_branch'
};

class SendInventoryModal extends React.Component {
  state = {
    loading: false,
    transferType: TRANSFER_TYPES.HOME_TO_BRANCH, // Default to home to branch
  };

  componentDidMount() {
    this.props.getAllBusinessBranches();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ loading: false });
    }
  }

  getHomeBranch = () => {
    const homeBranch = localStorage.getItem("homebranch")
      ? JSON.parse(localStorage.getItem("homebranch"))
      : null;
    return homeBranch;
  };

  getAvailableBranches = () => {
    return this.props.branches.filter(
      branch => branch.name.toLowerCase() !== "ecommerce"
    );
  };

  getSourceBranches = () => {
    const homeBranch = this.getHomeBranch();
    const { transferType } = this.state;
    
    switch (transferType) {
      case TRANSFER_TYPES.HOME_TO_BRANCH:
        // Only home branch can be source
        return homeBranch ? [homeBranch] : [];
      
      case TRANSFER_TYPES.BRANCH_TO_HOME:
        // Any branch except home branch can be source
        return this.getAvailableBranches().filter(
          branch => !homeBranch || branch.id !== homeBranch.id
        );
      
      case TRANSFER_TYPES.BRANCH_TO_BRANCH:
        // Any branch except home branch can be source
        return this.getAvailableBranches().filter(
          branch => !homeBranch || branch.id !== homeBranch.id
        );
      
      default:
        return this.getAvailableBranches();
    }
  };

  getDestinationBranches = (sourceBranchId) => {
    const homeBranch = this.getHomeBranch();
    const { transferType } = this.state;
    
    switch (transferType) {
      case TRANSFER_TYPES.HOME_TO_BRANCH:
        // Any branch except home branch and source can be destination
        return this.getAvailableBranches().filter(
          branch => (!homeBranch || branch.id !== homeBranch.id) && 
                   branch.id !== sourceBranchId
        );
      
      case TRANSFER_TYPES.BRANCH_TO_HOME:
        // Only home branch can be destination
        return homeBranch ? [homeBranch] : [];
      
      case TRANSFER_TYPES.BRANCH_TO_BRANCH:
        // Any branch except home branch and source can be destination
        return this.getAvailableBranches().filter(
          branch => (!homeBranch || branch.id !== homeBranch.id) && 
                   branch.id !== sourceBranchId
        );
      
      default:
        return this.getAvailableBranches().filter(
          branch => branch.id !== sourceBranchId
        );
    }
  };

  handleTransferTypeChange = (transferType) => {
    this.setState({ transferType });
    // Reset form fields when switching transfer types
    this.props.form.setFieldsValue({
      source_branch_id: undefined,
      business_branch_id: undefined,
    });
  };

  validateBranchSelection = (rule, value, callback) => {
    const { transferType } = this.state;
    const homeBranch = this.getHomeBranch();
    const form = this.props.form;
    const sourceBranchId = form.getFieldValue('source_branch_id');
    const destinationBranchId = form.getFieldValue('business_branch_id');
    
    // Prevent selecting the same branch as source and destination
    if (sourceBranchId && destinationBranchId && sourceBranchId === destinationBranchId) {
      callback("Source and destination branches cannot be the same");
      return;
    }
    
    // Prevent selecting home branch as both source and destination
    if (homeBranch && sourceBranchId === homeBranch.id && destinationBranchId === homeBranch.id) {
      callback("Cannot transfer from Home Branch to itself");
      return;
    }
    
    callback();
  };

  checkQuantity = (value, totalQuantity) => {
    console.log("vaka", value.quantity, totalQuantity);
    return Number(value.quantity) < Number(totalQuantity)
  }

  handleSendInventory = () => {
    const {
      form,
      product,
      sendInventory,
      updateProducts,
      closeModal,
      sendInventoryVariants,
      sendBranchProductToMain,
      sendBranchProductToBranch
    } = this.props;
    const { transferType } = this.state;

    form.validateFields((err, values) => {
      if (err) return;

      this.setState({ loading: true });

      let requestPayload;
      
      if (transferType === TRANSFER_TYPES.BRANCH_TO_HOME) {
        // Transfer from any branch to home branch - use sendBranchProductToMain API
        if (product.variants.length > 0) {
          const selectedVariant = product.variants.filter(variant => 
            values.variant_id.includes(variant.id)
          );

          if (selectedVariant.some(value => Number(value.quantity) < Number(values.quantity))) {
            this.setState({ loading: false });
            return Modal.warning({
              title: strings.youCantSendMoreThanStock,
            });
          }

          requestPayload = {
            products: [{
              product_id: product.id,
              source_branch_id: values.source_branch_id,
              quantity: values.quantity,
              variants_attributes: selectedVariant.map(variant => ({
                type: variant.type,
                value: variant.value,
                quantity: values.quantity,
                price: variant.price,
                cost_price: variant.cost_price
              }))
            }]
          };
        } else {
          requestPayload = {
            products: [{
              product_id: product.id,
              source_branch_id: values.source_branch_id,
              quantity: values.quantity
            }]
          };
        }

        // validate product quantity to send
        if (values.quantity > product.quantity) {
          Modal.warning({
            title: strings.youCantSendMoreThanStock,
          });
          this.setState({ loading: false });
        } else {
          sendBranchProductToMain(requestPayload)
            .then(res => {
              if (res && res.status === 200) {
                this.setState({ loading: false });
                form.resetFields();

                Modal.success({
                  title: strings.inventorySentSuccessfully,
                });

                updateProducts();
                closeModal();
              }
            })
            .catch(error => {
              this.setState({ loading: false });
              Modal.error({
                title: "Transfer Failed",
                content: error.response?.data?.error || "An error occurred during transfer",
              });
            });
        }
      } else if (transferType === TRANSFER_TYPES.HOME_TO_BRANCH) {
        // Transfer from home branch to other branches - use existing sendInventory/sendInventoryVariants API
        if(product.variants.length > 0){
          const selectedVariant = product.variants.filter(variant => values.variant_id.includes(variant.id));
          let variantArray = [];

          selectedVariant.map(val => variantArray.push({
            variant_id: val.id,
            product_id: product.id,
            type: val.type,
            value: val.value,
            quantity: values.quantity,
            business_branch_id: values.business_branch_id,
            cost_price: val.cost_price,
            price: val.price
          }));

          if(selectedVariant.some(value => Number(value.quantity) < Number(values.quantity))){
            this.setState({ loading: false });
            return Modal.warning({
              title: strings.youCantSendMoreThanStock,
            });
          }
          requestPayload = [...variantArray];
        }else{
          requestPayload = { 
            ...values, 
            product_id: product.id 
          };
        }

        // validate product quantity to send
        if (values.quantity > product.quantity) {
          Modal.warning({
            title: strings.youCantSendMoreThanStock,
          });
          this.setState({ loading: false });
        } else {
          if(product.variants.length > 0){
            sendInventoryVariants(requestPayload)
            .then(res => {
              if (res && res.status === 200) {
                this.setState({ loading: false });
                form.resetFields();
    
                Modal.success({
                  title: strings.inventorySentSuccessfully,
                });
    
                updateProducts();
                closeModal();
              }
            })
          }else{
            sendInventory(requestPayload).then(res => {
              if (res && res.status === 200) {
                this.setState({ loading: false });
                form.resetFields();
    
                Modal.success({
                  title: strings.inventorySentSuccessfully,
                });
    
                updateProducts();
                closeModal();
              }
            });
          }
        }
      } else {
        // Transfer between non-home branches - use sendBranchProductToBranch API
        if (product.variants.length > 0) {
          const selectedVariant = product.variants.filter(variant => 
            values.variant_id.includes(variant.id)
          );

          if (selectedVariant.some(value => Number(value.quantity) < Number(values.quantity))) {
            this.setState({ loading: false });
            return Modal.warning({
              title: strings.youCantSendMoreThanStock,
            });
          }

          requestPayload = [{
            product_id: product.id,
            source_branch_id: values.source_branch_id,
            target_branch_id: values.business_branch_id,
            quantity: values.quantity,
            variants_attributes: selectedVariant.map(variant => ({
              type: variant.type,
              value: variant.value,
              quantity: values.quantity,
              price: variant.price,
              cost_price: variant.cost_price
            }))
          }];
        } else {
          requestPayload = [{
            product_id: product.id,
            source_branch_id: values.source_branch_id,
            target_branch_id: values.business_branch_id,
            quantity: values.quantity
          }];
        }

        // validate product quantity to send
        if (values.quantity > product.quantity) {
          Modal.warning({
            title: strings.youCantSendMoreThanStock,
          });
          this.setState({ loading: false });
        } else {
          sendBranchProductToBranch(requestPayload)
            .then(res => {
              if (res && res.status === 200) {
                this.setState({ loading: false });
                form.resetFields();

                Modal.success({
                  title: strings.inventorySentSuccessfully,
                });

                updateProducts();
                closeModal();
              }
            })
            .catch(error => {
              this.setState({ loading: false });
              Modal.error({
                title: "Transfer Failed",
                content: error.response?.data?.error || "An error occurred during transfer",
              });
            });
        }
      }
    });
  };

  render() {
    const {
      showModal,
      closeModal,
      form: { getFieldDecorator, getFieldValue },
      product,
      sendType
    } = this.props;
    const { transferType } = this.state;

    const homeBranch = this.getHomeBranch();
    const sourceBranchId = getFieldValue('source_branch_id');
    const sourceBranches = this.getSourceBranches();
    const destinationBranches = this.getDestinationBranches(sourceBranchId);

    return (
      <Modal
        open={showModal}
        onCancel={closeModal}
        okText={sendType === "transfer" ? strings.requestTransfer : strings.sendInventory}
        cancelText={strings.cancel}
        title={`${strings.send} ${product.name}`}
        destoryOnClose
        okButtonProps={{ loading: this.state.loading }}
        onOk={this.handleSendInventory}
      >
        <Form layout="vertical" >
          {/* Transfer Type Selection */}
          <Form.Item label="Transfer Type">
            <Radio.Group
              value={transferType}
              onChange={(e) => this.handleTransferTypeChange(e.target.value)}
            >
              <Radio value={TRANSFER_TYPES.HOME_TO_BRANCH}>Home Branch to Other Branches</Radio>
              <Radio value={TRANSFER_TYPES.BRANCH_TO_HOME}>Other Branches to Home Branch</Radio>
              <Radio value={TRANSFER_TYPES.BRANCH_TO_BRANCH}>Branch to Branch</Radio>
            </Radio.Group>
          </Form.Item>

          {/* Source Branch Selection */}
          <Form.Item label="From Branch">
            {getFieldDecorator("source_branch_id", {
              rules: [
                {
                  required: true,
                  message: "Please select source branch",
                },
                {
                  validator: this.validateBranchSelection,
                }
              ],
            })(
              <Select
                showSearch
                placeholder="Select source branch"
                optionFilterProp="children"
                size="large"
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {sourceBranches &&
                  sourceBranches.map(branch => (
                    <Option key={branch.id} value={branch.id}>
                      {branch.name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>

          {/* Destination Branch Selection */}
          {(transferType === TRANSFER_TYPES.HOME_TO_BRANCH || transferType === TRANSFER_TYPES.BRANCH_TO_BRANCH) && (
            <Form.Item label="To Branch">
              {getFieldDecorator("business_branch_id", {
                rules: [
                  {
                    required: true,
                    message: strings.pleaseSelectABranch,
                  },
                  {
                    validator: this.validateBranchSelection,
                  }
                ],
              })(
                <Select
                  showSearch
                  placeholder={strings.searchForBranch}
                  optionFilterProp="children"
                  size="large"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {destinationBranches &&
                    destinationBranches.map(branch => (
                      <Option key={branch.id} value={branch.id}>
                        {branch.name}
                      </Option>
                    ))}
                </Select>
              )}
            </Form.Item>
          )}

          {/* Display destination for transfer to home branch */}
          {transferType === TRANSFER_TYPES.BRANCH_TO_HOME && homeBranch && (
            <Form.Item label="To Branch">
              <Select
                value={homeBranch.id}
                disabled
                size="large"
                style={{ width: "100%" }}
              >
                <Option value={homeBranch.id}>
                  {homeBranch.name} (Home Branch)
                </Option>
              </Select>
            </Form.Item>
          )}

          <Form.Item label={strings.quantity}>
            {getFieldDecorator("quantity", {
              rules: [
                {
                  required: true,
                  message: strings.pleaseEnterQuantityToSend,
                },
              ],
            })(<InputNumber size="large" style={{ width: "100%" }} />)}
          </Form.Item>

         {product.variants.length > 0 && <Form.Item>
            {getFieldDecorator("variant_id", {
              rules: [
                {
                  required: true,
                  message: strings.pleaseSelectAVariant,
                },
              ],
            })(
              <Select
                showSearch
                placeholder={strings.searchForVariant}
                optionFilterProp="children"
                size="large"
                style={{ width: "100%" }}
                mode="multiple"
                // filterOption={(input, option) =>
                //   option.props.children
                //     .toLowerCase()
                //     .indexOf(input.toLowerCase()) >= 0
                // }
              >
                {product.variants &&
                  product.variants.map(variant => (
                    <Option key={variant.id} value={variant.id}>
                      {variant.type} - {variant.value}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>}
        </Form>
      </Modal>
    );
  }
}

const SendInventoryForm = Form.create()(SendInventoryModal);

SendInventoryForm.propTypes = {
  branches: PropTypes.arrayOf(PropTypes.object).isRequired,
  error: PropTypes.string.isRequired,
  getAllBusinessBranches: PropTypes.func.isRequired,
  sendInventory: PropTypes.func.isRequired,
  getAllProducts: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  branches: state.branch.allBranches,
  error: state.error,
});

export default connect(mapStateToProps, {
  getAllBusinessBranches,
  sendInventory,
  getAllProducts,
  sendInventoryVariants,
  sendBranchProductToMain,
  sendBranchProductToBranch
})(SendInventoryForm);
